import React from "react";
import { Sparkles, Layers, CalendarClock, Rocket } from "lucide-react";
import { SectionHeading } from "@/components/PackSelection";

const blocks = [
  { icon: Sparkles, title: "Une sélection beauté", text: "Des produits pensés pour être présentés et proposés à votre clientèle." },
  { icon: Layers, title: "3 niveaux de pack", text: "Choisissez votre niveau de départ." },
  { icon: CalendarClock, title: "Une activité flexible", text: "Développez vos ventes en fonction de votre disponibilité." },
  { icon: Rocket, title: "Un démarrage simple", text: "Choisissez votre pack, recevez vos produits et commencez à les présenter." },
];

export const WhyOzentya = () => (
  <section className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
    <SectionHeading eyebrow="Pourquoi Ozentya" title="Pourquoi choisir Ozentya ?" />
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {blocks.map((b, i) => (
        <div
          key={i}
          data-testid={`why-block-${i}`}
          className="bg-white rounded-2xl border border-[var(--oz-border)] p-7 hover:shadow-[0_25px_50px_-30px_rgba(26,23,20,0.4)] transition-shadow"
        >
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[var(--oz-nude)] to-[var(--oz-bg-2)] flex items-center justify-center text-[var(--oz-gold)] mb-5">
            <b.icon className="w-6 h-6" />
          </div>
          <h3 className="font-serif text-xl text-[var(--oz-text)] mb-2">{b.title}</h3>
          <p className="text-sm text-[var(--oz-muted)] leading-relaxed">{b.text}</p>
        </div>
      ))}
    </div>
  </section>
);
